import { render, staticRenderFns } from "./ReletPostpone.vue?vue&type=template&id=630560ec&scoped=true"
import script from "./ReletPostpone.vue?vue&type=script&lang=js"
export * from "./ReletPostpone.vue?vue&type=script&lang=js"
import style0 from "./ReletPostpone.vue?vue&type=style&index=0&id=630560ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630560ec",
  null
  
)

export default component.exports